var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"MainBiddingDetail"}},[_c('BiddingDetail',{on:{"emitProjectDetail":_vm.callBackDataProjectDetail}}),_c('ItemBidding'),_c('Criteria'),_c('ProjectAttachment',{on:{"emitIsHaveFileTor":_vm.callBackIsHaveFileTor}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }